/* eslint-env browser */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'redux-router';
import has from 'lodash/has';

import { setHeader, loadInbox } from 'actions';

import Loading from 'components/common/Loading';
import EventList from 'components/calendar/EventList';
import EventListItem from 'components/calendar/EventListItem';

class InboxPage extends Component {
  constructor(props) {
    super(props);

    this.renderEventListItem = this.renderEventListItem.bind(this);
    this.getTitle = this.getTitle.bind(this);
  }

  getTitle() {
    let inboxTitle = 'Requests';

    if (has(window.CONFIG, 'ui')) {
      if (window.CONFIG.ui === 'card' || window.CONFIG.ui === 'shore2') {
        inboxTitle = 'Inbox';
      }
    }

    if (has(window.CONFIG, 'enable_dashboard')) {
      if (window.CONFIG.enable_dashboard === '1') {
        inboxTitle = 'Dashboard';
      }
    }

    return inboxTitle;
  }

  componentWillMount() {
    this.props.setHeader( this.getTitle() );
    this.props.loadInbox();
  }

  renderEventListItem(event, drawDivider = false) {
    return (
      <EventListItem
        drawDivider={drawDivider}
        showChevron
        event={event}
        key={`${event.date}_${event.id}`}
        onSelect={selectedEvent => this.props.push(`/inbox/details/${selectedEvent.id}`)}
      />
   );
  }

  render() {
    if (this.props.isLoading) {
      return (
        <Loading withWrapper />
      );
    }

    /**
     * @TODO
     *  [X] Load Inbox list from API and store in redux store (try loading one day of events for demo)
     *  [X] InboxPage should render a list of InboxCard views
     *  [X] InboxCard should store event changes to redux store to save pending changes
     *       - Instead InboxCard is holding event in state, will be responsible to sync to store when 'save'
     *  [X] Handle All Day Events
     *  [ ] Hanlde Multi-Day Events
     *  [ ] Handle Org Change
     *  [ ] Handle Location Change
     *  [ ] Require valid authentication for Inbox
     *  [ ] Redux action to submit changes to a specific event id
     *  [ ] What is the flow when they change data? Should "Accept" be the same action with changes or not?
     */

    if (this.props.events.length === 0) {
      return (
        <section className="inbox-page">
          <div className="inbox-no-events">
            <img
              src={`${window.EXPANDED_APP_ROOT}img/inbox_256px.png`}
              className="inboxLogoBig"
              alt="Inbox Logo"
              style={{ width: 220, height: 220 }}
            />
            <p>There are no requests for you to view right now.</p>
            <p>You will recieve a notification when the next one comes in.</p>
            <p>Until then... keep on keeping on &#58;&#41;</p>
          </div>
        </section>
      );
    }

    return (
      <section className="inbox-page">
        <EventList
          events={this.props.events}
          isLoading={this.props.isLoading}
          renderItem={this.renderEventListItem}
        />
      </section>
    );
  }
}

function mapStateToProps(state) {
  const { inbox } = state;
  const { events, isLoading } = inbox;

  return {
    isLoading,
    events,
  };
}

export default connect(mapStateToProps, {
  setHeader,
  loadInbox,
  push,
})(InboxPage);



// WEBPACK FOOTER //
// ./src/app/containers/InboxPage.js